import { DeploymentRequest } from "../../services/deployment-requests";
import { Option } from "../../util/option";
import { DisplayColumn, ErrorMessage } from "../../util/spreadsheet-data-utils";

export type ComponentDeploymentRequestListPageState = {
  /**
   * Page List
   */
  deploymentRequestList: ComponentDeploymentRequest[];
  dataList: {
    edhProtocolList: Option[];
  };
  searchForm: SearchForm;
  isEdited: boolean;
  fieldPath: FieldPath;
  displayColumn: DisplayColumn[];
};

export type SearchParam = {
  screenMode: string | undefined;
  dipByRegion: string | undefined;
  componentId: string | undefined;
  inOutTypeCd: string | undefined;
  edhPrtclTypeCd: string | undefined;
  startDate: string | undefined;
  endDate: string | undefined;
  environment: string | undefined;
};

export type SpreadSheetState = {
  deploymentRequestList: ComponentDeploymentRequest[];
  dataList: {
    edhProtocolList: Option[];
  };
  removeMilliseconds: (timestamp: string) => string;
};

export type DeploymentRequestRowStatus = {
  isSelected: string;
  isApproved: string;
  errorColumnList: string[];
  errorMessage: string;
  messageList: ErrorMessage[];
};

export type RowIndex = {
  index: number;
};

export type ComponentDeploymentRequest = DeploymentRequest &
  DeploymentRequestRowStatus &
  RowIndex;

export type cmpdplymntAttribute = {
  attributeKey: string;
  activeValue: string;
  currentValue: string;
};

export type SearchForm = {
  dipByRegion: string;
  componentId: string;
  protocol: string;
  scheduledDeploymentDate: {
    startDate: string;
    endDate: string;
  };
  environment: string;
  incClosed: boolean;
};
type FieldPath = {
  dipByRegion: string;
  componentId: string;
  protocol: string;
  scheduledDeploymentDate: string;
  environment: string;
};

export type PageNewState =
  | ComponentDeploymentRequestListPageState
  | ((
      prevState: ComponentDeploymentRequestListPageState,
    ) => ComponentDeploymentRequestListPageState);
